import { render, staticRenderFns } from "./TableBranceArea.vue?vue&type=template&id=449cef14"
import script from "./TableBranceArea.vue?vue&type=script&lang=js"
export * from "./TableBranceArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports